import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { UpdatePillar, UpdatePillarOwner } from '../../../UpdateData/UpdateCommunications';
import { loadingOwnerPillarDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { PILLAR, PILLAR_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDeleteComponentSpecifically from '../../../Modal/ModalDeleteComponentSpecifically';
import ChangeCoordManuallyDialog from './ChangeCoordManuallyDialog';
import { UpdateStatusComponents } from '../../../UpdateData/UpdateStatusComponent';

const PillarHighwayEditingDialog = ({ open, onClose, onClose2, content, highwayRefresh,  setIsComponentСhangeCoor, groupedCoordinatesWithColorTypeAndWidth,
  wellData,fobLocationData,couplingLocationData,ponBoxLocationData,pillarData, user}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [ownerPillarData, setOwnerPillarData] = useState([]); 
  const [ownerPillarId, setOwnerPillarId] = useState("");
  const [selectedOwnerPrice, setSelectedOwnerPrice] = useState(content.ownerWellPrice);
  const [openModalConnectionDelete, setOpenModalConnectionDelete] = useState(false);
  const [openModalChangeCoord, setOpenModalChangeCoord] = useState(false);
  

  const openModalConnectionComponentsDelete = () => {
    setOpenModalConnectionDelete(true);
  }; 

  const openModalChangeCoordinate = () => {
    setOpenModalChangeCoord(true);
  }; 

    //загрузка OwnerPillar
    useEffect(() => {
      const fetchOwnerPillarData = async () => {
        try {
          const data = await loadingOwnerPillarDataComponent();
          setOwnerPillarData(data);
        } catch (error) {
          //console.error("Error in fetchOwnerPillarData:", error);
        }
      };
      fetchOwnerPillarData(); 
    }, []); 

  const deletePillar = () => {
      UpdateStatusComponents(PILLAR, content.id, showSnackbar, user, highwayRefresh, handleCloseDialogs );
  };  

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };

  
  const updatePillar = () => {
    if (statusChange) {
      UpdatePillar(content.id, textComment, showSnackbar,content.authorId, highwayRefresh);
    } else {
      showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
    }
  };
  
  const handleChangePillarOwnerSelect = (event) => {
    const selectedPillarOwner = event.target.value;
    if (selectedPillarOwner === "") {
      setOwnerPillarId("");
      setSelectedOwnerPrice(null);
    } else {
      const selectedPillarOwner2 = ownerPillarData.find(pillarOwner => 
        `${pillarOwner.id}` === selectedPillarOwner
      );
      if (selectedPillarOwner2) {
        setOwnerPillarId(selectedPillarOwner2.id);
        setSelectedOwnerPrice(selectedPillarOwner2.price);
      }
    }
  };

  const updatePillarOwner = () => {
    if (ownerPillarId === "") {
      showSnackbar('Нет нужды в записи, собственник без изменений!', 'snackbarOk');
    } else {
      UpdatePillarOwner(content.id, ownerPillarId, showSnackbar,content.authorId, highwayRefresh );
    } 
  };

  const handleСhangeCoor= (event) => {
    handleCloseDialogs();
    setIsComponentСhangeCoor(true);
  }

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      <img src='./pillar.png' width='30' height='30' style={{ marginRight: "5px" }}/>
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование опоры</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.city}</span> </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Собственник:  </label>
        <select className="selectStyleDrawer" 

          onChange={(event) => {
            handleChangePillarOwnerSelect(event);
          }} >
          <option value="">{content.ownerPillarName}</option>
          {ownerPillarData.map(owner => (
            <option key={owner.id} value={owner.id}>{owner.name}</option>
          ))}
        </select>
        <button onClick={updatePillarOwner} class='buttonIsSaveDialog2'>Сохранить</button>

      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Тариф/км: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{selectedOwnerPrice} грн.</span> </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />
         <br/>
         <button onClick={updatePillar} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>
         
         <hr className='horizontalLineDialog'/>
         <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}> Редактировать на карте</button>
         <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
         <button  class='buttonIsEditDialog' onClick={openModalChangeCoordinate}>Изменить координаты вручную</button>
         <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
      <button class='buttonIsEditDialog' onClick={openModalConnectionComponentsDelete}>Удаление связей</button>
      <hr className='horizontalLineDialog'/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deletePillar} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" ,textShadow: '2px 2px 4px #3d3d3d'}}
        >
          Удалить
        </button>

        <span 
          style={{
            marginLeft: "5px",
            fontSize: "12px",
            color: "#bebebe",
            textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
          }}
        >
        Восстановление доступно в течение 24 часов
      </span>

      {/* <button className="buttonIsDeleteModal" onClick={deletePillar} style={{fontSize: "16px"}}>
        Удалить
        <span style={{ fontSize: "10px", display: "block", opacity: 0.8 }}>
          Восстановление доступно в течение 24 часов
        </span>
      </button> */}
      <hr className='horizontalLineDialog'/>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
          Закрыть
        </Button>
      </DialogActions>

      <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={PILLAR}
          flag={PILLAR_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

        <ChangeCoordManuallyDialog
         open={openModalChangeCoord}
         onClose={() => setOpenModalChangeCoord(false)}
         id={content.id}   
         user={content.authorId}
         cantonRefresh={highwayRefresh}
         flag={PILLAR}
        /> 

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={6000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />
    </Dialog>
  );
}

export default PillarHighwayEditingDialog;